import { run } from './projection';
export function scen(s) {
  return {
    base: run(s),
    bull: run({ ...s, ret: s.ret + 0.02, salGr: s.salGr + 0.01, hApp: s.hApp + 0.01 }),
    bear: run({ ...s, ret: Math.max(0.01, s.ret - 0.02), salGr: Math.max(0.01, s.salGr - 0.01), hApp: Math.max(0.005, s.hApp - 0.01), inflation: (s.inflation != null ? s.inflation : 0.025) + 0.01 }),
  };
}
